module.exports = "<div class=\"footer-wrapp\">\n  <hr />\n  <h4>2020 HEALTH <span class=\"razmak\">|</span>Všetky práva vyhradené</h4>\n</div>"